<form [formGroup]="form" (submit)="submitForm()">
  <mat-card class="p-4 bg-grey-button form-guardian-change">

    <h2
      data-pw="guardian_change_title"
      data-qa="guardian_change_title"
      aria-label="Guardian Change Request">
      Guardian Change Request
    </h2>

    <p class="form-guardian-change__subtitle">
      Complete this form to request that one or more students be assigned to a new parent or guardian.
    </p>

    <!-- Current Guardian -->
    <section class="form-guardian-change__section">

      <h3
        data-pw="current_guardian_section"
        data-qa="current_guardian_section"
        aria-label="Current Guardian Section">
        Current Guardian
      </h3>

      <div class="edit-field">
        <label
          for="currentParentNameInput"
          data-pw="current_parent_name_label"
          data-qa="current_parent_name_label"
          aria-label="Current Parent Name Label">
          Current Parent Name
        </label>

        <input
          id="currentParentNameInput"
          data-pw="current_parent_name_input"
          data-qa="current_parent_name_input"
          aria-label="Current Parent Name"
          matInput
          formControlName="currentParentName"
          readonly />
      </div>

    </section>

    <!-- New Guardian -->
    <section class="form-guardian-change__section">

      <h3
        data-pw="new_guardian_section"
        data-qa="new_guardian_section"
        aria-label="New Guardian Information Section">
        New Guardian Information
      </h3>

      <div class="edit-field">
        <label for="newGuardianFirstNameInput"
        data-pw="new_guardian_first_name_label"
        data-qa="new_guardian_first_name_label"
        aria-label="New Guardian First Name Label">
          First Name *
        </label>

        <input
          id="newGuardianFirstNameInput"
          data-pw="new_guardian_first_name_input"
          data-qa="new_guardian_first_name_input"
          matInput
          formControlName="newGuardianFirstName" />
      </div>

      <div class="edit-field">
        <label
          for="newGuardianLastNameInput"
          data-pw="new_guardian_last_name_label"
          data-qa="new_guardian_last_name_label"
          aria-label="New Guardian Last Name Label">
          Last Name *
        </label>


        <input
          id="newGuardianLastNameInput"
          data-pw="new_guardian_last_name_input"
          data-qa="new_guardian_last_name_input"
          matInput
          formControlName="newGuardianLastName" />
      </div>

      <div class="edit-field">
        <label
          for="newGuardianDobInput"
          data-pw="new_guardian_dob_label"
          data-qa="new_guardian_dob_label"
          aria-label="New Guardian Date Of Birth Label">
          Date of Birth *
        </label>

        <input
          id="newGuardianDobInput"
          data-pw="new_guardian_dob_input"
          data-qa="new_guardian_dob_input"
          matInput
          type="date"
          formControlName="newGuardianDateOfBirth" />
      </div>

      <div class="edit-field">
        <label
          for="newGuardianPidInput"
          data-pw="new_guardian_pid_label"
          data-qa="new_guardian_pid_label"
          aria-label="New Guardian PID Label">
          PID *
        </label>

        <input
          id="newGuardianPidInput"
          data-pw="new_guardian_pid_input"
          data-qa="new_guardian_pid_input"
          matInput
          formControlName="newGuardianPid" />
      </div>

      <div class="edit-field">
        <label
          for="newGuardianEmailInput"
          data-pw="new_guardian_email_label"
          data-qa="new_guardian_email_label"
          aria-label="New Guardian Email Label">
          Email *
        </label>

        <input
          id="newGuardianEmailInput"
          data-pw="new_guardian_email_input"
          data-qa="new_guardian_email_input"
          matInput
          formControlName="newGuardianEmail" />
      </div>

      <div class="edit-field">
        <label
          for="newGuardianPhoneInput"
          data-pw="new_guardian_phone_label"
          data-qa="new_guardian_phone_label"
          aria-label="New Guardian Phone Label">
          Phone
        </label>

        <input
          id="newGuardianPhoneInput"
          data-pw="new_guardian_phone_input"
          data-qa="new_guardian_phone_input"
          matInput
          formControlName="newGuardianPhone" />
      </div>

    </section>

    <!-- Student Selection -->
    <section class="form-guardian-change__section">

      <h3
        data-pw="students_section"
        data-qa="students_section"
        aria-label="Students Section">
        Students
      </h3>

      <p>
        Select one or more students that should be assigned to the new guardian.
      </p>

      <div formArrayName="students">

        @for (student of students.controls; track student; let i = $index) {

          <div [formGroupName]="i" class="form-guardian-change__student-row">

            <mat-checkbox
              [id]="'studentCheckbox_' + i"
              [attr.data-pw]="'student_checkbox_' + i"
              [attr.data-qa]="'student_checkbox_' + i"
              formControlName="selected"
              (change)="students.updateValueAndValidity()">

              {{ student.get('fullName')?.value }}

            </mat-checkbox>

          </div>
        }

      </div>

      @if (students.hasError('required') && students.touched) {
        <div class="form-guardian-change__validation-error">
            Select at least one student.
        </div>
      }

    </section>

    <!-- Certification -->
    <section class="form-guardian-change__section">

      <h3
        data-pw="certification_section"
        data-qa="certification_section"
        aria-label="Certification Section">
        Certification
      </h3>

      <p>
        I certify that the information provided on this guardian change request
        is complete and accurate.
      </p>

      <mat-checkbox
        id="certifiedCheckbox"
        data-pw="certified_checkbox"
        data-qa="certified_checkbox"
        formControlName="certified">

        I certify that the information provided is complete and accurate.

      </mat-checkbox>

    </section>

    @if (!form.disabled) {

      <div class="button-row">

        <button
          id="cancelButton"
          data-pw="cancel_button"
          data-qa="cancel_button"
          mat-stroked-button
          type="button"
          (click)="onBack()">

          Cancel

        </button>

        <button
          id="submitButton"
          data-pw="submit_button"
          data-qa="submit_button"
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="!isFormReady()">

          Submit

        </button>

      </div>
    }

  </mat-card>
</form>